import React from 'react';
import LifePathsFlow from './LifePathsFlow';

function App() {
  return (
    <div className="App">
      <LifePathsFlow />
    </div>
  );
}

export default App; 